import React from 'react';

const DefaultConversionExplanation = ({ fromUnit, toUnit }) => {
  return (
    <div>
      <h3>Conversion Explanation</h3>
      <p>The explanation for converting from {fromUnit} to {toUnit} is not available yet.</p>
    </div>
  );
};

export default DefaultConversionExplanation;